import ForumOrtu from "./src/ForumOrtu";

export default ForumOrtu;